export const addMenuDialogTranslations = {
    en: {
        parentMenu: "Parent Menu",
        name: "Name",
        nameRequired: "Name is required",
        url: "URL",
        urlRequired: "URL is required",
        icon: "Icon",
        iconRequired: "Icon is required",
        menuOrder: "Menu Order",
        menuOrderRequired: "Menu order is required",
        menuOrderTypeError: "Must be a number",
        isNavigation: "Is Navigation",
        submit: "Submit",
        submitSuccess: "Menu saved successfully",
        submitError: "Something went wrong!"
    },
    mr: {
        parentMenu: "पालक मेनू",
        name: "नाव",
        nameRequired: "नाव आवश्यक आहे",
        url: "URL",
        urlRequired: "URL आवश्यक आहे",
        icon: "चिन्ह",
        iconRequired: "चिन्ह आवश्यक आहे",
        menuOrder: "मेनू क्रम",
        menuOrderRequired: "मेनू क्रम आवश्यक आहे",
        menuOrderTypeError: "संख्या असणे आवश्यक आहे",
        isNavigation: "नेव्हिगेशन आहे",
        submit: "सबमिट करा",
        submitSuccess: "मेनू यशस्वीरित्या जतन केला",
        submitError: "काहीतरी चूक झाली!"
    }
};
